module.exports = __webpack_public_path__ + "media/src/images/received_gifts/bnr-about-giftee-db2201905c432fcbb6da0de8a8c96479.svg";